import type { NumberConvertor } from "@/hooks/useNumberConvertor"

export const IssuesImpacted =
  (props: { abbreviateNumber: NumberConvertor["abbreviateNumber"] }) =>
  (value: { impacted: number; total: number }) =>
    props.abbreviateNumber(value?.impacted || 0)
